import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TEditCustomerDetailsReduxParams } from '~types/feat/customer';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchDeleteCustomer(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerDeleteCustomerAttempt', handleDeleteCustomer, api);
}

function* handleDeleteCustomer(api: CustomerGateway, data: PayloadAction<TEditCustomerDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const customerId = reduxState.customer.customerDetails.customerId;

    if (!customerId) {
        yield put(combinedActions.customerDeleteCustomerFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.deleteCustomer], {
        authToken,
        customerId,
        ...data.payload,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerDeleteCustomerFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const customerListing = reduxState.customer.customerListing.data;

        const massagedCustomerListing = customerListing.map(item => {
            if (item.customerId === customerId) {
                return {
                    ...item,
                    updatedAt: dayjs().toISOString(),
                };
            }

            return item;
        });

        yield put(combinedActions.customerSetCustomerListingData(massagedCustomerListing));
        yield put(combinedActions.customerDeleteCustomerSuccess());
        yield put(combinedActions.customerSetDeleteCustomerModalIsOpen(false));
        yield put(combinedActions.customerGetCustomerListingAttempt());

        toast.success(SuccessMessages.CustomerDeleteCustomerSuccess);
    }
}
